import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import Config from "../components/Config";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useAuthHandling } from './useAuthhandling';

function Addadmin() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [add, setAds] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [formerror, setError] = useState({});

  let name, value;

  const handleInputs = (e) => {
    console.log(e);
    name = e.target.name;
    value = e.target.value;
    setAds({ ...add, [name]: value });
  };

  const validate = (values) => {
    const errors = {};
    if (!values.name) {
      errors.name = "Name is required!";
    }

    if (!values.email) {
      errors.email = "Email is required!";
    }
    if (!values.password) {
      errors.password = "Password is required!";
    }

    return errors;
  };

  const PostData = async (e) => {
    e.preventDefault();
    const { name, email, password } = add;
    const ress = validate(add);
    setError(ress);
    if (!ress.name && !ress.email && !ress.password) {
      const formData = new FormData();
      formData.append("name", add.name);
      formData.append("email", add.email);
      formData.append("password", add.password);
      const res = await fetch(`${Config.apiurl}/api/v1/crm/create-admin-user`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: add.name,
          password: add.password,
          email: add.email,
        }),
        // axios.post(`${Config.apiurl}/api/v1/crm/create-admin-user`, formData,{ headers: {

        //   Authorization: `Bearer ${Cookies.get('a_token')}`,
        // },})
      }).then((res) => {
        if (res.status === 200) {
          toast.success("Sucessfully Created Admin", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          window.location.href=("/dashboard")
        }
        else if(res.status === 401){
          handleUnauthorized();
          PostData();
        }
        else {
          toast.error("Something went wrong", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Admin</h4>
                    <p className="card-description"> New Admin</p>
                    <form className="forms-sample">
                      {/* <form className="forms-sample"> */}
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="name"
                          name="name"
                          value={add.name}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>{formerror.name}</label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="email"
                          name="email"
                          value={add.email}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.email}
                        </label>
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputUsername1">Password</label>
                        <input
                          type="password"
                          className="form-control"
                          id="exampleInputUsername1"
                          placeholder="password"
                          name="password"
                          value={add.password}
                          onChange={handleInputs}
                        />
                        <label style={{ color: "red" }}>
                          {formerror.password}
                        </label>
                      </div>

                      <button
                        type="submit"
                        onClick={PostData}
                        className="btn btn-primary me-2"
                      >
                        Submit
                      </button>
                      <ToastContainer />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Addadmin;
